import { useEffect } from 'react';

const Actions = (vm) => {
    const validControls = () => {
        if (!vm.menuOpen) return;
        const onDocClick = (e) => {
            if (!vm.menuRef.current || !vm.btnRef.current) return;
            if (!vm.menuRef.current.contains(e.target) && !vm.btnRef.current.contains(e.target)) {
            vm.setMenuOpen(false);
            }
        };
        const onKey = (e) => e.key === 'Escape' && vm.setMenuOpen(false);
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }

    useEffect(() => {validControls()}, [vm.menuOpen]);
};

export default Actions;
